import { toast } from "react-toastify";

const NETWORK_TOAST_ID = "api-network-error";

export const getApiToastMessage = (
  error: any,
  fallback = "Something went wrong"
) => {
  const status = error?.response?.status ?? error?.status;
  const responseData = error?.response?.data ?? error;
  const rawText =
    typeof responseData === "string"
      ? responseData
      : error?.message || error?.toString?.() || "";

  if (status === 503) return "API server is unavailable right now (503)";
  if (!error?.response && /network error/i.test(rawText)) {
    return "Unable to connect to the API server";
  }
  if (typeof responseData === "string" && responseData.trim()) {
    return responseData;
  }
  if (responseData?.message) return String(responseData.message);
  if (responseData?.errorMessage) return String(responseData.errorMessage);
  if (rawText) return rawText;

  return fallback;
};

export const showApiErrorToast = (
  error: any,
  fallback = "Something went wrong"
) => {
  const message = getApiToastMessage(error, fallback);
  const isNetworkLike =
    /network error|unable to connect|unavailable|503/i.test(message);

  toast.error(message, {
    toastId: isNetworkLike ? NETWORK_TOAST_ID : message,
  });
};
